import { useMemo } from 'react'

import { ApiKeyEndpointMetadata } from '~/gen/proto/bff/v1/model_pb'
import { useApiKeyRoles } from '~/pages/ApiKeys/hooks/useApiKeyRoles'

// 全件(query='')から計算する。検索で絞り込まれた一覧を使うと、選択済みロールが検索結果から
// 外れている間そのロールのエンドポイントがサマリーから消え、実際に発行されるキーで
// 呼び出せる数より少なく表示されてしまうため。
export function useSelectedEndpoints(
  selectedRoleNames: string[],
): ApiKeyEndpointMetadata[] {
  const roles = useApiKeyRoles('')

  return useMemo(() => {
    const endpoints = roles
      .filter((role) => selectedRoleNames.includes(role.name))
      .flatMap((role) => role.endpoints)
    return endpoints.filter(
      (endpoint, index) =>
        index ===
        endpoints.findIndex(
          (e) => e.method === endpoint.method && e.path === endpoint.path,
        ),
    )
  }, [roles, selectedRoleNames])
}
